export default function ({ store, redirect }) {
  if (store.getters["user/IS_BAND"]) return redirect("/band/parameter/")
  else if (store.getters["user/IS_INF"])
    return redirect("/influencer/parameter/")
  else return redirect("/")
}
